import { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  TextField,
  FormControlLabel,
  IconButton,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import PropTypes from "prop-types";
import Checkbox from "@material-ui/core/Checkbox";
import { green } from "@material-ui/core/colors";
import { Modal } from "../../../Modal";
import { FileInput } from "../../../../../common/fileinput/fileinput";
import { ErrorMessages } from "../../../errorMessages";
import { useStyles } from "./headerBrowser.style";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const noimgurl = "/noimage.png";
const initialStateErrorsForm = [];
const FOLDERACTION = 2;
const FILEACTION = 3;

export const HeaderBrowser = ({
  isFetching,
  applySearch,
  debouncedHandleFilterChange,
  handleCreateFolder,
  handleCreateFile,
  request,
  isSearching,
}) => {
  const classes = useStyles();
  const [openFolderDialog, setOpenFolderDialog] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [searchFile, setSearchFile] = useState("");
  const [openDialogFile, setOpenDialogFile] = useState(false);
  const [file, setFile] = useState(null);
  const [clear, setClear] = useState(false);
  const [errorsForm, setErrorsForm] = useState(initialStateErrorsForm);
  const [uploading, setUploading] = useState(false);
  const [isPrivate, setIsPrivate] = useState({ folder: false, file: false });

  useEffect(() => {
    if (request.type === FILEACTION) setUploading(false);
    if (request.type === FILEACTION && !request.isError) {
      setClear(true);
      setFile(null);
      setOpenDialogFile(false);
    } else if (request.type === FOLDERACTION) {
      setOpenFolderDialog(false);
    }
  }, [request]);

  const resetErrors = () => {
    setErrorsForm(initialStateErrorsForm);
  };

  const setError = (key, message) => {
    setErrorsForm((prevState) => {
      return [...prevState, { key, message }];
    });
  };

  /** Search file */
  const handleChangeInput = (event) => {
    const { value } = event.target;
    applySearch(true);
    setSearchFile(value);
  };

  useEffect(() => {
    if (isSearching) debouncedHandleFilterChange(searchFile, "keyword");
  }, [debouncedHandleFilterChange, searchFile]);
  /** Create folder */
  const createFolder = () => {
    resetErrors();

    if (folderName.length) handleCreateFolder(folderName, isPrivate.folder);
    else setError("folderName", "The folder name is required");
  };
  const handleFolderName = (event) => {
    const { value } = event.target;
    setFolderName(value);
  };

  /** Create file */
  const handleImageUpload = (e) => {
    resetErrors();
    setFile(e);
  };

  const createFile = () => {
    setUploading(true);
    if (file !== null) handleCreateFile(file, isPrivate.file);
    else {
      setError("file", "The file input is required");
      setUploading(false);
    }
  };

  const handleChangeChechbox = (event) => {
    const { checked, name } = event.target;
    setIsPrivate({ ...isPrivate, [name]: checked });
  };

  return (
    <>
      <Paper className={classes.newPaper}>
        <Grid container style={{ marginTop: 2 }}>
          <Grid item lg={8} md={8} sm={12} xs={12} className={classes.newFlex}>
            <TextField
              className={classes.textField}
              variant="outlined"
              value={searchFile}
              placeholder="Search"
              name="keyword"
              onChange={handleChangeInput}
              InputProps={{
                classes: { input: classes.input },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Clear search"
                      onClick={() => {
                        setIsPrivate({ folder: false, file: false });
                        setSearchFile("");
                      }}
                    >
                      <ClearIcon className={classes.adormentColor} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>
      <Modal
        actionsDisabled={isFetching}
        title="Create folder"
        open={openFolderDialog}
        confirmButtonText="SAVE"
        cancelButtonText="CLOSE"
        onConfirm={() => {
          createFolder();
        }}
        onClose={() => {
          setOpenFolderDialog(false);
        }}
      >
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ErrorMessages errorMessages={errorsForm} onClose={resetErrors} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Folder name"
              name="folderName"
              value={folderName}
              onChange={handleFolderName}
            />
          </Grid>
          <Grid item lg={7} md={7} sm={6} xs={4}>
            &nbsp;
          </Grid>
          <Grid item lg={5} md={5} sm={6} xs={8} className={classes.textRight}>
            <FormControlLabel
              control={
                <GreenCheckbox
                  checked={isPrivate.folder}
                  onChange={handleChangeChechbox}
                  name="folder"
                />
              }
              label="Private"
            />
          </Grid>
        </Grid>
      </Modal>

      <Modal
        actionsDisabled={isFetching}
        title="Create File"
        open={openDialogFile}
        confirmButtonText="SAVE"
        cancelButtonText="CLOSE"
        actionConfirmDisabled={file === null || errorsForm.length}
        onConfirm={createFile}
        onClose={() => {
          setOpenDialogFile(false);
        }}
      >
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ErrorMessages
              disableScrollToTop
              errorMessages={errorsForm}
              onClose={resetErrors}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FileInput
              cssClassName={classes.dragAndDrop}
              height="150px"
              name="file"
              text="File"
              value=""
              onHandleChange={(e) => handleImageUpload(e)}
              clear={clear}
              placeholder={noimgurl}
              inputProps={{
                "data-testid": "file",
              }}
              noimg={file || noimgurl}
              maxSize={20000000}
              acceptFile={[
                "image/jpeg",
                "image/gif",
                "image/png",
                "image/svg+xml",
                "text/csv",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/pdf",
                "text/plain",
              ]}
              uploading={uploading}
            />
          </Grid>
          <Grid item lg={7} md={7} sm={6} xs={4}>
            &nbsp;
          </Grid>
          <Grid item lg={5} md={5} sm={6} xs={8} className={classes.textRight}>
            <FormControlLabel
              control={
                <GreenCheckbox
                  checked={isPrivate.file}
                  onChange={handleChangeChechbox}
                  name="file"
                />
              }
              label="Private"
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            &nbsp;
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};
HeaderBrowser.propTypes = {
  debouncedHandleFilterChange: PropTypes.func.isRequired,
  handleCreateFolder: PropTypes.func.isRequired,
  handleCreateFile: PropTypes.func.isRequired,
  request: PropTypes.instanceOf(Object).isRequired,
  applySearch: PropTypes.func.isRequired,
  isSearching: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
};
